<script>
    export default {
        props: ['users'],
        data() {
            return {
                sortProperty: 'name',
                sortDirection: 'asc',
                filterTerm: '',
                selected: []
            }
        },
        methods: {
            sort(ev, property) {
                ev.preventDefault();
                this.sortProperty = property;
                this.sortDirection = (this.sortDirection === 'asc') ? 'desc' : 'asc';
            },
            selectAll() {
                if (this.selected.length > 0) {
                    this.selected = [];
                } else {
                    for (let user in this.UserList) {
                        this.selected.push(this.users[user].id);
                    }
                }
            }
        },
        computed: {
            UserList() {
                return _.orderBy(this.users, this.sortProperty, this.sortDirection)
                    .filter((user) => {
                        var searchRegex = new RegExp(this.filterTerm, 'i');
                        return searchRegex.test(user.name) || searchRegex.test(user.email)
                    })
            }
        }
    }
</script>